import styled from 'styled-components';

export const PopoverContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  width: 200px;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const UrlDisplay = styled.div`
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
`;

export const UrlText = styled.div`
  font-size: 12px;
  color: #666;
  word-break: normal;
  overflow-wrap: normal;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MenuOptions = styled.div`
  padding: 0 4px;
`;

export const MenuButton = styled.button<{ isDelete?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px;
  background: transparent;
  gap: 8px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: ${props => props.isDelete ? '#e74c3c' : '#333'};
  transition: background-color 0.2s ease;
  margin-bottom: 2px;

  &:hover {
    background-color: ${props => props.isDelete ? '#fef2f2' : '#f5f5f5'};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ButtonIcon = styled.span`
  margin-right: 12px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
